<template>
  <div class="search_page">
    <!-- 背景光球 -->
    <div class="bg_orb orb_4"></div>
    <div class="bg_orb orb_5"></div>
    <!-- 网格纹理 -->
    <div class="grid_pattern"></div>

    <!-- 顶部横幅区域 -->
    <div class="hero_section">
      <div class="hero_content">
        <h1 class="hero_title">
          <span class="title_highlight">发现</span>精彩直播
        </h1>
        <p class="hero_subtitle">探索万千主播，找到属于你的精彩世界</p>
      </div>
    </div>

    <!-- 搜索头部 - 居中 -->
    <div class="search_header">
      <div class="search_input_wrap">
        <input
          v-model="searchKeyword"
          type="text"
          placeholder="搜索主播"
          class="search_input"
          @keyup.enter="handleSearch"
        />
        <i v-if="searchKeyword" class="el-icon-close clear_icon" @click="clearSearch"></i>
        <span class="search_btn" @click="handleSearch">
          <i class="el-icon-search"></i>
          搜索
        </span>
      </div>
    </div>

    <!-- 搜索内容区域 -->
    <div class="search_content">
      <!-- 未搜索时显示装饰内容 -->
      <template v-if="!hasSearched">
        <div class="default_content">
          <!-- 欢迎区域 -->
          <div class="welcome_section">
            <p class="welcome_desc">搜索你感兴趣的主播，开启互动之旅</p>
          </div>

          <!-- 热门搜索 -->
          <div class="hot_search_section">
            <div class="section_header">
              
              <h3 class="section_title"><i class="el-icon-s-data"></i>热门搜索</h3>
            </div>
            <div class="hot_tags">
              <span
                v-for="(item, index) in hotList"
                :key="index"
                class="hot_tag"
                :class="{ hot_top: index < 3 }"
                @click="quickSearch(item)"
              >
                <span class="hot_num">{{ index + 1 }}</span>
                {{ item }}
              </span>
            </div>
          </div>

          <!-- 搜索历史居中 -->
          <div v-if="searchHistory.length > 0" class="history_section">
            <div class="section_header">
             
              <h3 class="section_title"> <i class="el-icon-time"></i>搜索历史</h3>
              <span class="clear_history" @click="clearHistory">清空</span>
            </div>
            <div class="history_list">
              <span
                v-for="(item, index) in searchHistory"
                :key="index"
                class="history_tag"
                @click="quickSearch(item)"
              >
                {{ item }}
              </span>
            </div>
          </div>


        </div>
      </template>

      <!-- 搜索结果 -->
      <div v-else class="search_result">
        <!-- 加载状态 -->
        <div v-if="loading" class="loading_state">
          <i class="el-icon-loading"></i>
          <span>搜索中...</span>
        </div>

        <!-- 搜索结果内容 -->
        <div v-else-if="searchResults.length > 0" class="result_content">
          <!-- 左侧：搜索结果 -->
          <div class="result_left">
            <!-- 结果统计 -->
            <div class="result_stats">
              找到 <span class="highlight">"{{ searchKeyword }}"</span>，共 <span class="highlight count">{{ searchResults.length }}</span> 个主播
            </div>

            <!-- 精选主播（第一个结果） -->
            <div v-if="searchResults[0]" class="featured_anchor">
              <h3 class="block_title">精选主播</h3>
              <div class="featured_card" @click="enterLiveRoom(searchResults[0].id, searchResults[0].anchorid)">
                <img :src="searchResults[0].touxiang" class="featured_avatar" />
                <div class="featured_info">
                  <span class="featured_name">{{ searchResults[0].anchor_name }}</span>
                  <div class="featured_meta">
                    <span v-if="searchResults[0].statuss == 1" class="live_status">
                      <span class="live_dot"></span>直播中
                    </span>
                    <span class="meta_item">粉丝数: {{ searchResults[0].hot || 0 }}</span>
                    <span class="meta_item">房间号: {{ searchResults[0].id }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 相关主播列表 -->
            <div class="anchor_list_section">
              <div class="block_header">
                <h3 class="block_title">相关主播</h3>
              </div>
              <div class="anchor_list">
                <div
                  v-for="item in searchResults.slice(1)"
                  :key="item.id"
                  class="anchor_item"
                  @click="enterLiveRoom(item.id, item.pos)"
                >
                  <div class="item_avatar_wrap">
                    <img :src="item.touxiang" class="item_avatar" />
                    <span v-if="item.statuss == 1" class="item_live_tag">直播中</span>
                  </div>
                  <span class="item_name">{{ item.anchor_name }}</span>
                  <span class="item_fans">粉丝数: {{ item.hot || 0 }}</span>
                </div>
              </div>
            </div>
          </div>


        </div>

        <!-- 空状态 -->
        <div v-else class="empty_state">
          <div class="empty_icon_wrap">
            <i class="el-icon-search"></i>
          </div>
          <p class="empty_text">未找到 "{{ searchKeyword }}" 相关的主播</p>
          <p class="empty_tip">换个关键词试试吧</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SearchPage',
  data() {
    return {
      // 搜索关键词
      searchKeyword: '',
      // 是否已搜索
      hasSearched: false,
      // 加载状态
      loading: false,
      // 当前Tab
      activeTab: 'anchor',
      // 搜索结果列表
      searchResults: [],
      // 搜索历史（从本地存储读取）
      searchHistory: [],
      // 热门搜索榜单
      hotList: ['然',  '凝', 'wyp2', '郑一点','会弹琴的小林']
    }
  },
  mounted() {
    // 从本地存储加载搜索历史
    this.loadSearchHistory()
  },
  methods: {
    // 从本地存储加载搜索历史
    loadSearchHistory() {
      const history = localStorage.getItem('searchHistory')
      if (history) {
        this.searchHistory = JSON.parse(history)
      }
    },
    // 保存搜索历史到本地存储
    saveSearchHistory() {
      localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory))
    },
    // 执行搜索
    handleSearch() {
      const keyword = this.searchKeyword.trim()
      if (!keyword) {
        this.$message.warning('请输入搜索关键词')
        return
      }
      // 添加到搜索历史
      this.addToHistory(keyword)
      // 设置已搜索状态
      this.hasSearched = true
      this.loading = true
      // 调用搜索接口
      axios.get('https://guangxing.xiangyouhulian.cn/api/index/search', {
        params: {
          title: keyword
        }
      }).then(response => {
        this.loading = false
        if (response.data.code === 1) {
          this.searchResults = response.data.data || []
        } else {
          this.searchResults = []
          this.$message.error(response.data.msg || '搜索失败')
        }
      }).catch(error => {
        this.loading = false
        this.searchResults = []
        console.error('搜索请求失败:', error)
        this.$message.error('网络错误，请稍后重试')
      })
    },
    // 添加到搜索历史
    addToHistory(keyword) {
      // 移除重复项
      const index = this.searchHistory.indexOf(keyword)
      if (index > -1) {
        this.searchHistory.splice(index, 1)
      }
      // 添加到开头
      this.searchHistory.unshift(keyword)
      // 最多保留10条
      if (this.searchHistory.length > 10) {
        this.searchHistory = this.searchHistory.slice(0, 10)
      }
      this.saveSearchHistory()
    },
    // 快速搜索（点击历史或热门标签）
    quickSearch(keyword) {
      this.searchKeyword = keyword
      this.handleSearch()
    },
    // 清空搜索
    clearSearch() {
      this.searchKeyword = ''
      this.hasSearched = false
      this.searchResults = []
    },
    // 清空搜索历史
    clearHistory() {
      this.searchHistory = []
      localStorage.removeItem('searchHistory')
    },
    // 返回上一页
    goBack() {
      this.$router.back()
    },
    // 进入直播间
    enterLiveRoom(id, anchorid) {
      this.$router.push(`/zb/${anchorid}/${id}`)
    }
  }
}
</script>

<style scoped lang="scss">
// 搜索页面容器
.search_page {
  min-height: 100%;
  background: #f4f4f5;
  display: flex;
  flex-direction: column;
  position: relative;
}

// 旧版深色背景装饰元素统一隐藏（保留节点与 class）
.bg_orb,
.bg_orb.orb_4,
.bg_orb.orb_5,
.grid_pattern {
  display: none;
}

// 顶部横幅区域
.hero_section {
  position: relative;
  padding: 32px 16px 8px;
  background: transparent;
}

.hero_bg {
  display: none;
}

// 横幅内容
.hero_content {
  position: relative;
  z-index: 1;
  text-align: center;
}

.hero_title {
  font-size: 26px;
  font-weight: 700;
  color: #18191c;
  margin-bottom: 8px;
  letter-spacing: 1px;

  .title_highlight {
    color: #fb7299;
  }
}

.hero_subtitle {
  font-size: 13px;
  color: #9499a0;
  letter-spacing: 0.5px;
}

// 搜索头部 - 居中
.search_header {
  display: flex;
  justify-content: center;
  margin: 16px 0 24px;
  padding: 0 16px;
  position: relative;
  z-index: 10;
}

// 搜索输入框容器
.search_input_wrap {
  display: flex;
  align-items: center;
  width: 640px;
  max-width: 100%;
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 6px;
  overflow: hidden;
  transition: border-color 0.2s ease;

  &:focus-within {
    border-color: #fb7299;
  }
}

// 搜索输入框
.search_input {
  flex: 1;
  padding: 12px 16px;
  font-size: 14px;
  color: #18191c;
  background: transparent;
  border: none;
  outline: none;

  &::placeholder {
    color: #9499a0;
  }
}

// 清空图标
.clear_icon {
  font-size: 15px;
  color: #9499a0;
  cursor: pointer;
  padding: 6px;
  margin-right: 4px;
  border-radius: 50%;
  transition: color 0.2s ease, background-color 0.2s ease;

  &:hover {
    color: #fb7299;
    background: #fff0f5;
  }
}

// 搜索按钮
.search_btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background: #fb7299;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #ff85ad;
  }

  i {
    font-size: 15px;
  }
}

// Tab 导航（保留样式）
.tab_nav {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f2f3;
}

// Tab 项
.tab_item {
  font-size: 14px;
  color: #61666d;
  cursor: pointer;
  padding: 8px 4px;
  position: relative;
  transition: color 0.2s ease;

  &:hover {
    color: #fb7299;
  }

  &.active {
    color: #fb7299;
    font-weight: 600;

    &::after {
      content: '';
      position: absolute;
      bottom: -13px;
      left: 0;
      right: 0;
      height: 2px;
      background: #fb7299;
      border-radius: 2px;
    }
  }
}

// 搜索内容区域
.search_content {
  max-width: 720px;
  margin: 0 auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px 40px;
  box-sizing: border-box;
}

// 默认内容布局（未搜索时）
.default_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

// 欢迎区域
.welcome_section {
  text-align: center;
  margin-bottom: 20px;
  z-index: 1;

  .welcome_title {
    font-size: 17px;
    font-weight: 600;
    color: #18191c;
    margin-bottom: 8px;
  }

  .welcome_desc {
    font-size: 13px;
    color: #9499a0;
  }
}

// 欢迎图标（保留样式）
.welcome_icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff0f5;
  border: 1px solid #ffe4ec;
  border-radius: 8px;
  color: #fb7299;
}

// 热门搜索卡片
.hot_search_section {
  width: 640px;
  max-width: 100%;
  margin-bottom: 16px;
  z-index: 1;
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 8px;
  padding: 20px 24px;
  box-sizing: border-box;

  .section_header {
    color: #18191c;
  }
}

.hot_tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.hot_tag {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  font-size: 13px;
  color: #61666d;
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 6px;
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;

  &:hover {
    border-color: #fb7299;
    color: #fb7299;
    background: #fff7fa;
  }

  &.hot_top {
    background: #fff0f5;
    border-color: #ffd3e0;
    color: #fb7299;

    &:hover {
      background: #ffe4ec;
      border-color: #fb7299;
    }

    .hot_num {
      background: #fb7299;
      color: #fff;
    }
  }
}

.hot_num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  font-size: 11px;
  font-weight: 600;
  color: #9499a0;
  background: #f1f2f3;
  border-radius: 4px;
}

// 搜索历史卡片
.history_section {
  width: 640px;
  max-width: 100%;
  z-index: 1;
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 8px;
  padding: 20px 24px;
  box-sizing: border-box;

  .section_header {
    color: #18191c;
  }
}

// 区块头部
.section_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

// 区块标题
.section_title {
  font-size: 16px;
  font-weight: 600;
  color: #18191c;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;

  i {
    color: #fb7299;
    font-size: 16px;
  }

  &::before {
    content: '';
    width: 3px;
    height: 14px;
    background: #fb7299;
    border-radius: 2px;
  }
}

// 清空历史按钮
.clear_history {
  font-size: 12px;
  color: #9499a0;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #fb7299;
  }
}

// 历史标签列表
.history_list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

// 历史标签
.history_tag {
  padding: 6px 14px;
  font-size: 12px;
  color: #61666d;
  background: #f1f2f3;
  border-radius: 6px;
  cursor: pointer;
  transition: color 0.2s ease, background-color 0.2s ease;

  &:hover {
    color: #fb7299;
    background: #ffe4ec;
  }
}

// 榜单列表（保留样式）
.rank_list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// 榜单项
.rank_item {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 6px 0;
  transition: color 0.2s ease;

  &:hover {
    .rank_text {
      color: #fb7299;
    }
  }
}

// 榜单排名
.rank_num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #9499a0;
  background: #f1f2f3;
  border-radius: 4px;

  &.top {
    color: #fff;
    background: #fb7299;
  }
}

// 榜单文字
.rank_text {
  font-size: 14px;
  color: #61666d;
  transition: color 0.2s ease;
}

// 搜索结果区域
.search_result {
  min-height: 320px;
}

// 加载状态
.loading_state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 0;
  color: #9499a0;

  i {
    font-size: 36px;
    margin-bottom: 16px;
  }

  span {
    font-size: 13px;
  }
}

// 搜索结果内容布局
.result_content {
  display: flex;
  gap: 24px;
}

// 结果左侧
.result_left {
  flex: 1;
  min-width: 0;
}

// 结果统计
.result_stats {
  font-size: 13px;
  color: #61666d;
  margin-bottom: 16px;

  .highlight {
    color: #fb7299;

    &.count {
      font-weight: 600;
    }
  }
}

// 精选主播
.featured_anchor {
  margin-bottom: 24px;
}

// 块标题
.block_title {
  font-size: 16px;
  font-weight: 600;
  color: #18191c;
  margin: 0 0 12px;
}

// 精选卡片
.featured_card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #fb7299;

    .featured_name {
      color: #fb7299;
    }
  }
}

// 精选头像
.featured_avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e3e5e7;
  flex-shrink: 0;
}

// 精选信息
.featured_info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

// 精选名称
.featured_name {
  font-size: 16px;
  font-weight: 600;
  color: #18191c;
  transition: color 0.2s ease;
}

// 精选元信息
.featured_meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 12px;
  color: #9499a0;
}

// 直播状态
.live_status {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #fb7299;
  font-weight: 500;
}

// 直播红点
.live_dot {
  width: 6px;
  height: 6px;
  background: #fb7299;
  border-radius: 50%;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}

// 元信息项
.meta_item {
  color: #9499a0;
}

// 相关主播卡片
.anchor_list_section {
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 8px;
  padding: 20px 24px;
}

// 块头部
.block_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  .block_title {
    margin-bottom: 0;
  }
}

// 主播列表
.anchor_list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 16px;
}

// 主播项
.anchor_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 88px;
  cursor: pointer;

  &:hover {
    .item_name {
      color: #fb7299;
    }

    .item_avatar {
      border-color: #fb7299;
    }
  }
}

// 项头像容器
.item_avatar_wrap {
  position: relative;
  width: 72px;
  height: 72px;
  margin-bottom: 8px;
}

// 项头像
.item_avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e3e5e7;
  transition: border-color 0.2s ease;
}

// 项直播标签
.item_live_tag {
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  padding: 1px 6px;
  font-size: 11px;
  line-height: 16px;
  color: #fff;
  background: #fb7299;
  border-radius: 4px;
  white-space: nowrap;
}

// 项名称
.item_name {
  font-size: 13px;
  color: #18191c;
  margin-bottom: 4px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  transition: color 0.2s ease;
}

// 项粉丝数
.item_fans {
  font-size: 12px;
  color: #9499a0;
}

// 空状态
.empty_state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 72px 0;
}

// 空状态图标容器
.empty_icon_wrap {
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff0f5;
  border: 1px solid #ffe4ec;
  border-radius: 50%;
  margin-bottom: 20px;

  i {
    font-size: 32px;
    color: #fb7299;
  }
}

// 空状态文字
.empty_text {
  font-size: 15px;
  font-weight: 500;
  color: #61666d;
  margin-bottom: 8px;
}

// 空状态提示
.empty_tip {
  font-size: 13px;
  color: #9499a0;
}

// 响应式适配
@media (max-width: 900px) {
  .default_content,
  .result_content {
    flex-direction: column;
  }

  .right_section,
  .result_right {
    width: 100%;
  }
}
</style>
